export enum ConferenceLabel {
    'Clarence Campbell' = 'Clarence Campbell',
    'Eastern' = 'Eastern',
    'National Hockey League' = 'National Hockey League',
    'Prince of Wales' = 'Prince of Wales',
    'Western' = 'Western',
    'Wildcard' = 'Wildcard',
    'World Cup of Hockey' = 'World Cup of Hockey',
}

export enum DivisionLabel {
    'Adams' = 'Adams',
    'American' = 'American',
    'Atlantic' = 'Atlantic',
    'Canadian' = 'Canadian',
    'Central' = 'Central',
    'Discover Central' = 'Discover Central',
    'East' = 'East',
    'European' = 'European',
    'Group A' = 'Group A',
    'Group B' = 'Group B',
    'Honda West' = 'Honda West',
    'MassMutual East' = 'MassMutual East',
    'Metropolitan' = 'Metropolitan',
    'Norris' = 'Norris',
    'North American' = 'North American',
    'Northeast' = 'Northeast',
    'Northwest' = 'Northwest',
    'Pacific' = 'Pacific',
    'Patrick' = 'Patrick',
    'Scotia North' = 'Scotia North',
    'Smythe' = 'Smythe',
    'Southeast' = 'Southeast',
    'West' = 'West',
    'Wild Card' = 'Wild Card',
}

export enum ClinchIndicator {
    conferenceClinch = 'z',
    divisionClinch = 'y',
    playoffClinch = 'x',
    presidentsTrophy = 'p',
    eliminated = 'e',
}

export enum RankAccessor {
    conference = 'conferenceSequence',
    division = 'divisionSequence',
    league = 'leagueSequence',
    wildcard = 'wildcardSequence',
}

export enum StandingsViewType {
    conference = 'conference',
    division = 'division',
    league = 'league',
    wildcard = 'wildcard',
}

export enum StandingsViewTypeLabel {
    conference = 'Conference',
    division = 'Division',
    league = 'League',
    wildcard = 'Wild Card',
}
